module.exports = __webpack_public_path__ + "img/NovelShort_logo.9b31bbc6.png";